/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { gql, useLazyQuery } from '@apollo/client';
import { apolloCMSClient } from '@exo/frontend-common-apollo';

export const useRetrieveRefreshTimeout = () => {
  const GQL_Retrieve_Refresh_Timeout= gql`
        query RetrieveRefreshTimeDetails {
          retrieveRefreshTimeDetails {
          viewTimeInMs
          cutOffTimeInMs
          currentTimeInMs
          remainingTimeInSec
          refreshRequired
        }
      }
  `
   const [retrieveRefreshTimeout,retrieveRefreshTimeoutData] = useLazyQuery(GQL_Retrieve_Refresh_Timeout, {
    context: { headers: { authorization: null } }
  });
  return {retrieveRefreshTimeout,retrieveRefreshTimeoutData};
};

